mutation TravelAuthorizationAccountingUnstamper(
  $input: TravelAuthorizationAccountingUnstamperInput!
) {
  travelAuthorizationAccountingUnstamper(input: $input) {
    travelAuthorization {
      id
      _isAccountingEntry
      _isHistory
      _isStampAllowed
      _isUnstampAllowed
      _isRevisable
      _rowTimestamp
      stampedEntityDocumentId
    }
  }
}
